<template>
  <!-- eslint-disable -->
  <v-row class="pt-2 mt-n4" style="min-height: 100vv">
    <v-col cols="12">
      <v-row class="recolher">
        <v-col cols="11" md="11" class="mx-auto">
          <!-- Combos -->

          <template
            v-if="
              (this.combos != `` &&
                this.busca == '' &&
                this.mutableSelecionado == 'Delivery' &&
                this.combos.find(
                  (val) =>
                    val.delivery == true ||
                    (val.delivery == undefined && val.encomenda == undefined),
                )) ||
              (this.mutableSelecionado == 'Encomendas' &&
                this.combos.find((val) => val.encomenda == true)) ||
              ('combos'.toLowerCase().match(this.busca) &&
                this.mutableSelecionado == 'Delivery' &&
                this.combos.find(
                  (val) =>
                    val.delivery == true ||
                    (val.delivery == undefined && val.encomenda == undefined),
                )) ||
              (this.mutableSelecionado == 'Encomendas' &&
                this.combos.find((val) => val.encomenda == true))
            "
          >
            <div :class="`Categoria-${0}`" :ref="`Categoria-${0}`" :id="`Categoria-${0}`">
              <v-list
                v-model:opened="openCategorias"
                style="display: table !important; min-width: 100%"
              >
                <v-list-group
                  value="Combos"
                  style="display: table-row !important"
                >
                  <template v-slot:activator="{ props }">
                    <v-list-item v-bind="props">
                      <h2 class="ml-0">
                        <faT
                          icon="circle-arrow-right"
                          class="mr-2"
                          :color="dadosEmpresa.corBase"
                        />
                        Combos
                      </h2>
                    </v-list-item>
                  </template>
                  <v-row class="d-flex justify-space-start">
                    <template v-for="(combo, index) in this.combos">
                      <v-col
                        cols="12"
                        md="4"
                        v-if="
                          (!combo.delivery &&
                            !combo.encomenda &&
                            mutableSelecionado == 'Delivery' &&
                            this.busca == '') ||
                          (combo.delivery == true &&
                            mutableSelecionado == 'Delivery' &&
                            this.busca == '') ||
                          (!combo.delivery &&
                            !combo.encomenda &&
                            mutableSelecionado == 'Delivery' &&
                            combo.nome
                              .toLowerCase()
                              .match(busca.toLowerCase())) ||
                          (combo.delivery == true &&
                            mutableSelecionado == 'Delivery' &&
                            combo.nome.toLowerCase().match(busca.toLowerCase()))
                        "
                      >
                        <div :class="` d-flex align-center flex-column mb-10`">
                          <v-card
                            min-height="170px"
                            id="vcardProduto"
                            max-height="170px"
                            @click="(combo.dialog = true), desabilitaScroll(), validaHorario()"
                            width="100%"
                          >
                            <v-row align="center">
                              <v-col cols="4">
                                <div class="ml-3 mt-2 mb-2 rounded">
                                  <img
                                    :style="
                                      'width: 100px; height: 125px; border-radius: 8px; border: 0.5px solid' +
                                      dadosEmpresa.corBase +
                                      '; object-fit: cover;'
                                    "
                                    :src="combo.img_url"
                                  />
                                </div>
                              </v-col>
                              <v-col cols="8">
                                <v-card-title class="pa-0">{{
                                  combo.nome
                                }}</v-card-title>
                                <div style="max-height: 50px; overflow-y: auto">
                                  <p class="pa-0" style="opacity: 60%">
                                    {{ combo.descricao }}
                                  </p>
                                </div>
                                <v-card-title class="pa-0">
                                  <p
                                    :style="
                                      'font-size:14px; color: ' +
                                      dadosEmpresa.corBase
                                    "
                                  >
                                    R${{ combo.valor }}
                                  </p>
                                </v-card-title>
                              </v-col>
                              <!-- <v-tooltip location="top" text="Caso deseje solicitar o mesmo produto com tamanhos diferentes, será possivel na tela de finalização" >
                              <template v-slot:activator="{ props }">
                                <div v-bind="props" style="position: absolute; right: 10px; top: 10px; cursor: pointer"  class="text-right">
                                  
                                  <v-icon  color="red">mdi-help-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-tooltip> -->
                            </v-row>
                          </v-card>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        v-if="
                          (combo.encomenda == true &&
                            mutableSelecionado == 'Encomendas') ||
                          (combo.encomenda == true &&
                            mutableSelecionado == 'Encomendas' &&
                            combo.nome.toLowerCase().match(busca.toLowerCase()))
                        "
                      >
                        <div
                          @click="(combo.dialog = true), desabilitaScroll()"
                          :class="` d-flex align-center flex-column mb-10`"
                        >
                          <v-card
                            min-height="170px"
                            id="vcardProduto"
                            max-height="170px"
                            width="100%"
                            @click="(combo.dialog = true), desabilitaScroll()"
                          >
                            <v-row align="center">
                              <v-col cols="4">
                                <div class="ml-3 mt-2 mb-2 rounded">
                                  <img
                                    :style="
                                      'width: 100px; height: 125px; border-radius: 8px; border: 0.5px solid' +
                                      dadosEmpresa.corBase +
                                      '; object-fit: cover;'
                                    "
                                    :src="combo.img_url"
                                  />
                                </div>
                              </v-col>
                              <v-col cols="8">
                                <v-card-title class="pa-0">{{
                                  combo.nome
                                }}</v-card-title>
                                <div style="max-height: 50px; overflow-y: auto">
                                  <p class="pa-0" style="opacity: 60%">
                                    {{ combo.descricao }}
                                  </p>
                                </div>
                                <v-card-title class="pa-0">
                                  <p
                                    :style="
                                      'font-size:14px; color: ' +
                                      dadosEmpresa.corBase
                                    "
                                  >
                                    R${{ combo.valor }}
                                  </p>
                                </v-card-title>
                              </v-col>
                              <!-- <v-tooltip location="top" text="Caso deseje solicitar o mesmo produto com tamanhos diferentes, será possivel na tela de finalização" >
                              <template v-slot:activator="{ props }">
                                <div v-bind="props" style="position: absolute; right: 10px; top: 10px; cursor: pointer"  class="text-right">
                                  
                                  <v-icon  color="red">mdi-help-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-tooltip> -->
                            </v-row>
                          </v-card>
                        </div>
                      </v-col>
                      <div
                        id="dialogFeitoCombos"
                        style="overflow-y: scroll"
                        v-if="combo.dialog"
                      >
                        <v-row>
                          <v-col
                            class="mx-auto"
                            cols="12"
                            md="4"
                            id="dialogCol"
                          >
                            <v-card
                              style="overflow-y: auto !important"
                              class="px-5"
                              id="dialogCard"
                            >
                              <v-row class="d-flex justify-end">
                                <v-col cols="1" class="mr-3">
                                  <v-btn
                                    class="mt-5"
                                    size="md"
                                    @click="
                                      (combo.dialog = false),
                                        desabilitaScroll(),
                                        (this.open = [])
                                    "
                                    elevation="0"
                                    icon
                                  >
                                    <v-icon color="red"
                                      >mdi-close</v-icon
                                    ></v-btn
                                  >
                                </v-col>
                              </v-row>
                              <v-card-title>{{ combo.nome }}</v-card-title>
                              <v-col cols="6" class="mx-auto">
                                <div class="rounded d-flex justify-center">
                                  <img
                                    class="mx-auto"
                                    :style="
                                      'width: 132px; height: 165px; border-radius: 8px; border: 0.5px solid' +
                                      dadosEmpresa.corBase +
                                      '; object-fit: cover'
                                    "
                                    :src="combo.img_url"
                                  />
                                </div>
                              </v-col>
                              <v-col cols="12">
                                <p class="pa-0" style="opacity: 60%">
                                  {{ combo.descricao }}
                                </p>
                              </v-col>
                              <v-col cols="12">
                                <v-card-title class="pa-0">
                                  <p
                                    :style="
                                      'font-size:14px; color: ' +
                                      dadosEmpresa.corBase
                                    "
                                  >
                                    R${{ combo.valor }}
                                  </p>
                                </v-card-title>
                                <p style="opacity: 60%">Produtos:</p>
                                <div style="opacity: 60%" class="ml-3">
                                  <template
                                    v-for="produtos in combo.produtos"
                                    :key="produtos"
                                  >
                                    <div class="mt-2">
                                      <div v-if="!produtos.tamSelecionado">
                                        {{
                                          produtos.nome +
                                          " x " +
                                          produtos.quantidade
                                        }}
                                      </div>
                                      <div v-if="produtos.tamSelecionado">
                                        {{
                                          produtos.nome +
                                          " " +
                                          produtos.tamSelecionado.descricao +
                                          " x " +
                                          produtos.quantidade
                                        }}
                                      </div>
                                      <template
                                        v-if="produtos.saborSelecionado"
                                      >
                                        <span>Sabor:</span>
                                        <template
                                          v-for="(
                                            sabor, index
                                          ) in produtos.saborSelecionado"
                                          :key="sabor"
                                        >
                                          <span
                                            v-if="
                                              index + 1 ==
                                              produtos.saborSelecionado.length
                                            "
                                            >{{ sabor.descricao }}</span
                                          >
                                          <span v-else>{{
                                            sabor.descricao + ","
                                          }}</span>
                                        </template>
                                      </template>
                                    </div>
                                  </template>
                                </div>
                              </v-col>
                              <v-divider></v-divider>
                              <v-card-title> </v-card-title>
                              <v-card-actions class="d-flex justify-center">
                                <p style="opacity: 60%">Quantidade:</p>

                                <v-btn
                                  id="valor"
                                  variant="text"
                                  :color="dadosEmpresa.corBase"
                                  size="large"
                                  icon
                                  v-if="combo.quantidade >= 2"
                                  @click="
                                    (combo.quantidade -= 1), (reveal = true)
                                  "
                                >
                                  <v-icon
                                    size="large"
                                    :color="dadosEmpresa.corBase"
                                    >mdi-minus-circle-outline</v-icon
                                  >
                                </v-btn>

                                <v-btn
                                  id="valor"
                                  variant="text"
                                  :color="dadosEmpresa.corBase"
                                  v-if="combo.quantidade == 1"
                                  size="large"
                                  icon
                                  @click="
                                    (reveal = true),
                                      (combo.quantidade = 0),
                                      removeCarrinho(combo)
                                  "
                                >
                                  <v-icon
                                    size="large"
                                    :color="dadosEmpresa.corBase"
                                    >mdi-minus-circle-outline</v-icon
                                  >
                                </v-btn>
                                <v-btn
                                  id="valor"
                                  variant="text"
                                  :color="dadosEmpresa.corBase"
                                  size="large"
                                  icon
                                  disabled
                                  v-if="combo.quantidade == 0"
                                >
                                  <v-icon
                                    size="large"
                                    :color="dadosEmpresa.corBase"
                                    >mdi-minus-circle-outline</v-icon
                                  >
                                </v-btn>
                                <v-card-subtitle class="mt-1">
                                  <p
                                    :style="
                                      'font-size:14px; color: ' +
                                      dadosEmpresa.corBase
                                    "
                                  >
                                    {{ combo.quantidade }} x
                                  </p>
                                </v-card-subtitle>
                                <v-btn
                                  id="valor"
                                  v-if="combo.quantidade < 1"
                                  :disabled="
                                    !this.horario &&
                                    this.mutableSelecionado == 'Delivery'
                                  "
                                  variant="text"
                                  :color="dadosEmpresa.corBase"
                                  size="large"
                                  icon
                                  @click="
                                    (combo.quantidade += 1), (reveal = true)
                                  "
                                >
                                  <v-icon
                                    size="large"
                                    :color="dadosEmpresa.corBase"
                                    >mdi-plus-circle-outline</v-icon
                                  >
                                </v-btn>

                                <v-btn
                                  v-if="combo.quantidade >= 1"
                                  id="valor"
                                  variant="text"
                                  :color="dadosEmpresa.corBase"
                                  size="large"
                                  icon
                                  @click="
                                    (combo.quantidade += 1), (reveal = true)
                                  "
                                >
                                  <v-icon
                                    size="large"
                                    :color="dadosEmpresa.corBase"
                                    >mdi-plus-circle-outline</v-icon
                                  >
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                            <div class="d-flex">
                              <v-btn
                                class="bg-red"
                                :style="'width: 50%; border-radius: 0px; height: 50px'"
                                @click="
                                  (combo.dialog = false),
                                    desabilitaScroll(),
                                    (this.open = [])
                                "
                                elevation="0"
                                >Voltar
                                <v-icon color="white"
                                  >mdi-arrow-left-bottom</v-icon
                                ></v-btn
                              >
                              <div style="width: 50%" @click="alertaSelect()">
                                <v-btn
                                  style="
                                    width: 100%;
                                    border-radius: 0px;
                                    height: 50px;
                                  "
                                  class="bg-green"
                                  :disabled="
                                    combo.quantidade == 0 && !combo.quantidade
                                  "
                                  @click="
                                    enviaPreco(combo, true),
                                      (combo.dialog = false),
                                      desabilitaScroll(),
                                      (this.open = [])
                                  "
                                  >adicionar <v-icon>mdi-plus</v-icon></v-btn
                                >
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </template>
                  </v-row>
                </v-list-group>
              </v-list>
            </div>
          </template>
          <!-- produtos  -->
          <!--Faz um loop em categorias e gera 1 div para cada categoria com seu respectivo nome-->

          <template
            v-for="(categoria, index) in categoriasPush"
            :key="categoria.id"
          >
          <div :class="`Categoria-${categoria.id}`"
              :ref="`Categoria-${categoria.id}`"
              :id="`Categoria-${categoria.id}`">
              <v-list
              
              v-if="
                (busca == '' &&
                  this.produtosPush.find(
                    (val) => val.categoria == categoria.id,
                  )) ||
                (categoria.nome.toLowerCase().match(busca.toLowerCase()) &&
                  this.produtosPush.find(
                    (val) => val.categoria == categoria.id,
                  ))
              "
              v-model:opened="openCategorias"
              style="display: table !important; min-width: 100%"
            >
              <v-list-group
                :value="categoria.nome"
                style="display: table-row !important"
              >
                <template v-slot:activator="{ props }">
                  <v-list-item v-bind="props">
                    <h2 class="ml-0">
                      <faT
                        icon="circle-arrow-right"
                        class="mr-2"
                        :color="dadosEmpresa.corBase"
                      />
                      {{ categoria.nome }}
                    </h2>
                  </v-list-item>
                </template>
                <v-row class="d-flex justify-space-start">
                  <template
                    v-for="(produto, index) in produtosPush"
                    :key="index"
                  >
                    <v-col
                      cols="12"
                      md="4"
                      v-if="
                        (produto.delivery == undefined &&
                          mutableSelecionado == 'Delivery' &&
                          produto.categoria == categoria.id &&
                          this.busca == '') ||
                        (produto.delivery == true &&
                          mutableSelecionado == 'Delivery' &&
                          produto.categoria == categoria.id &&
                          this.busca == '') ||
                        (produto.delivery == undefined &&
                          mutableSelecionado == 'Delivery' &&
                          produto.categoria == categoria.id &&
                          produto.nome
                            .toLowerCase()
                            .match(busca.toLowerCase())) ||
                        (produto.delivery == true &&
                          mutableSelecionado == 'Delivery' &&
                          produto.categoria == categoria.id &&
                          produto.nome.toLowerCase().match(busca.toLowerCase()))
                      "
                    >
                      <div>
                        <div
                          class="d-flex align-center flex-column mb-10"
                          v-if="
                            (produto.tamanhoUnic == true &&
                              produto.categoria == categoria.id &&
                              busca == '') ||
                            (produto.tamanhoUnic == true &&
                              produto.codbarras == busca) ||
                            (produto.tamanhoUnic == true &&
                              produto.categoria == categoria.id &&
                              produto.nome
                                .toLowerCase()
                                .match(busca.toLowerCase())) ||
                            (produto.tamanhoUnic == true &&
                              produto.categoria == categoria.id &&
                              categoria.nome
                                .toLowerCase()
                                .match(busca.toLowerCase()))
                          "
                        >
                          <v-card
                            width="100%"
                            @click="
                              (this.produtoSelecionado = produto),
                                validaHorario(),                            
                                (produtoIndex = index),
                                (this.produtoSelecionado.dialog = true),
                                desabilitaScroll(),
                                validaDisabledSabor(produto)
                            "
                            min-height="170px"
                            id="vcardProduto"
                            max-height="170px"
                            style="overflow-y: auto"
                            class="mt-2 pb-3"
                            v-if="produto.categoria == categoria.id"
                          >
                            <v-row align="center">
                              <v-col cols="4">
                                <div class="ml-3 mt-2 mb-2 rounded">
                                  <img
                                    :style="
                                      'width: 100px; height: 125px; border-radius: 8px; border: 0.5px solid' +
                                      dadosEmpresa.corBase +
                                      '; object-fit: cover;'
                                    "
                                    :src="produto.img_url"
                                  />
                                </div>
                              </v-col>
                              <v-col cols="8">
                                <v-card-title class="pa-0">{{
                                  produto.nome
                                }}</v-card-title>
                                <div style="max-height: 50px; overflow-y: auto">
                                  <p class="pa-0" style="opacity: 60%">
                                    {{ produto.descricao }}
                                  </p>
                                </div>

                                <v-card-title
                                  class="pa-0"
                                  v-if="produto.saborComp"
                                >
                                  <p
                                    :style="
                                      'font-size:14px; color:' +
                                      dadosEmpresa.corBase
                                    "
                                  >
                                    A partir de R${{ produto.valor }}
                                  </p>
                                </v-card-title>
                                <v-card-title
                                  class="pa-0"
                                  v-if="!produto.saborComp"
                                >
                                  <p
                                    :style="
                                      'font-size:14px; color:' +
                                      dadosEmpresa.corBase
                                    "
                                  >
                                    R${{ produto.valor }}
                                  </p>
                                </v-card-title>
                              </v-col>
                            </v-row>
                          </v-card>
                        </div>

                        <!-- Mais de um tamanho -->
                        <div
                          class="d-flex align-center flex-column mb-10"
                          v-if="
                            (produto.tamanhoComp == true &&
                              produto.categoria == categoria.id &&
                              busca == '') ||
                            (produto.tamanhoComp == true &&
                              produto.codbarras == busca) ||
                            (produto.tamanhoComp == true &&
                              produto.categoria == categoria.id &&
                              produto.nome
                                .toLowerCase()
                                .match(busca.toLowerCase())) ||
                            (produto.tamanhoComp == true &&
                              produto.categoria == categoria.id &&
                              categoria.nome
                                .toLowerCase()
                                .match(busca.toLowerCase()))
                          "
                        >
                          <v-card
                            width="100%"
                            @click="
                              (this.produtoSelecionado = produto),
                              validaHorario(),
                                (produtoIndex = index),
                                (this.produtoSelecionado.dialog = true),
                                desabilitaScroll(),
                                validaDisabledSabor(produto)
                            "
                            min-height="170px"
                            id="vcardProduto"
                            max-height="170px"
                            style="overflow-y: auto"
                            class="mt-2 pb-3"
                            v-if="produto.categoria == categoria.id"
                          >
                            <v-row align="center">
                              <v-col cols="4">
                                <div class="ml-3 mt-2 mb-2 rounded">
                                  <img
                                    :style="
                                      'width: 100px; height: 125px; border-radius: 8px; border: 0.5px solid' +
                                      dadosEmpresa.corBase +
                                      '; object-fit: cover;'
                                    "
                                    :src="produto.img_url"
                                  />
                                </div>
                              </v-col>
                              <v-col cols="8">
                                <v-card-title class="pa-0">{{
                                  produto.nome
                                }}</v-card-title>
                                <div style="max-height: 50px; overflow-y: auto">
                                  <p class="pa-0" style="opacity: 60%">
                                    {{ produto.descricao }}
                                  </p>
                                </div>
                                <v-card-title class="pa-0">
                                  <p
                                    :style="
                                      'font-size:14px; color: ' +
                                      dadosEmpresa.corBase
                                    "
                                  >
                                    A partir de R${{ produto.valor }}
                                  </p>
                                </v-card-title>
                              </v-col>
                              <!-- <v-tooltip location="top" text="Caso deseje solicitar o mesmo produto com tamanhos diferentes, será possivel na tela de finalização" >
                              <template v-slot:activator="{ props }">
                                <div v-bind="props" style="position: absolute; right: 10px; top: 10px; cursor: pointer"  class="text-right">
                                  
                                  <v-icon  color="red">mdi-help-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-tooltip> -->
                            </v-row>
                          </v-card>
                        </div>
                      </div>
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                      v-if="
                        produto.encomenda == true &&
                        mutableSelecionado == 'Encomendas' &&
                        produto.categoria == categoria.id
                      "
                    >
                      <div>
                        <div
                          class="d-flex align-center flex-column mb-10"
                          v-if="
                            (produto.tamanhoUnic == true &&
                              produto.categoria == categoria.id &&
                              busca == '') ||
                            (produto.tamanhoUnic == true &&
                              produto.codbarras == busca) ||
                            (produto.tamanhoUnic == true &&
                              produto.categoria == categoria.id &&
                              produto.nome
                                .toLowerCase()
                                .match(busca.toLowerCase())) ||
                            (produto.tamanhoUnic == true &&
                              produto.categoria == categoria.id &&
                              categoria.nome
                                .toLowerCase()
                                .match(busca.toLowerCase()))
                          "
                        >
                          <v-card
                            width="100%"
                            @click="
                              (this.produtoSelecionado = produto),
                                (produtoIndex = index),
                                (this.produtoSelecionado.dialog = true),
                                desabilitaScroll(),
                                validaDisabledSabor(produto)
                            "
                            min-height="170px"
                            id="vcardProduto"
                            max-height="170px"
                            style="overflow-y: auto"
                            class="mt-2 pb-3"
                            v-if="produto.categoria == categoria.id"
                          >
                            <v-row align="center">
                              <v-col cols="4">
                                <div class="ml-3 mt-2 mb-2 rounded">
                                  <img
                                    :style="
                                      'width: 100px; height: 125px; border-radius: 8px; border: 0.5px solid' +
                                      dadosEmpresa.corBase +
                                      '; object-fit: cover;'
                                    "
                                    :src="produto.img_url"
                                  />
                                </div>
                              </v-col>
                              <v-col cols="8">
                                <v-card-title class="pa-0">{{
                                  produto.nome
                                }}</v-card-title>
                                <div style="max-height: 50px; overflow-y: auto">
                                  <p class="pa-0" style="opacity: 60%">
                                    {{ produto.descricao }}
                                  </p>
                                </div>
                                <v-card-title
                                  class="pa-0"
                                  v-if="produto.saborComp"
                                >
                                  <p
                                    :style="
                                      'font-size:14px; color: ' +
                                      dadosEmpresa.corBase
                                    "
                                  >
                                    A partir de R${{ produto.valor }}
                                  </p>
                                </v-card-title>
                                <v-card-title
                                  class="pa-0"
                                  v-if="!produto.saborComp"
                                >
                                  <p
                                    :style="
                                      'font-size:14px; color: ' +
                                      dadosEmpresa.corBase
                                    "
                                  >
                                    R${{ produto.valor }}
                                  </p>
                                </v-card-title>
                              </v-col>
                            </v-row>
                          </v-card>
                        </div>

                        <!-- Mais de um tamanho -->
                        <div
                          class="d-flex align-center flex-column mb-10"
                          v-if="
                            (produto.tamanhoComp == true &&
                              produto.categoria == categoria.id &&
                              busca == '') ||
                            (produto.tamanhoComp == true &&
                              produto.codbarras == busca) ||
                            (produto.tamanhoComp == true &&
                              produto.categoria == categoria.id &&
                              produto.nome
                                .toLowerCase()
                                .match(busca.toLowerCase())) ||
                            (produto.tamanhoComp == true &&
                              produto.categoria == categoria.id &&
                              categoria.nome
                                .toLowerCase()
                                .match(busca.toLowerCase()))
                          "
                        >
                          <v-card
                            width="100%"
                            @click="
                              (this.produtoSelecionado = produto),
                                (produtoIndex = index),
                                (this.produtoSelecionado.dialog = true),
                                desabilitaScroll(),
                                validaDisabledSabor(produto)
                            "
                            min-height="170px"
                            id="vcardProduto"
                            max-height="170px"
                            style="overflow-y: auto"
                            class="mt-2 pb-3"
                            v-if="produto.categoria == categoria.id"
                          >
                            <v-row align="center">
                              <v-col cols="4">
                                <div class="ml-3 mt-2 mb-2 rounded">
                                  <img
                                    :style="
                                      'width: 100px; height: 125px; border-radius: 8px; border: 0.5px solid' +
                                      dadosEmpresa.corBase +
                                      '; object-fit: cover;'
                                    "
                                    :src="produto.img_url"
                                  />
                                </div>
                              </v-col>
                              <v-col cols="8">
                                <v-card-title class="pa-0">{{
                                  produto.nome
                                }}</v-card-title>
                                <div style="max-height: 50px; overflow-y: auto">
                                  <p class="pa-0" style="opacity: 60%">
                                    {{ produto.descricao }}
                                  </p>
                                </div>
                                <v-card-title class="pa-0">
                                  <p
                                    :style="
                                      'font-size:14px; color: ' +
                                      dadosEmpresa.corBase
                                    "
                                  >
                                    A partir de R${{ produto.valor }}
                                  </p>
                                </v-card-title>
                              </v-col>
                            </v-row>
                          </v-card>
                        </div>
                      </div>
                    </v-col>
                  </template>
                </v-row>
              </v-list-group>
            </v-list>
          </div>
            
            <!--Faz um loop em produtos e gera 1 div para cada produto correspondente a cada categoria com seu respectivo nome-->
          </template>
          <div
            class="dialogFeito"
            style="overflow-y: scroll"
            v-if="produtoSelecionado.dialog && !produtoSelecionado.tamanhoComp"
          >
            <v-row>
              <v-col class="mx-auto" cols="12" md="4" id="dialogCol">
                <v-card
                  style="overflow-y: auto !important"
                  class="px-5"
                  id="dialogCard"
                >
                  <v-row class="d-flex justify-end">
                    <v-col cols="1" class="mr-3">
                      <v-btn
                        class="mt-5"
                        size="md"
                        @click="
                          (this.produtoSelecionado.dialog = false),
                            desabilitaScroll(),
                            (this.open = [])
                        "
                        elevation="0"
                        icon
                      >
                        <v-icon color="red">mdi-close</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                  <v-card-title>{{ produtoSelecionado.nome }}</v-card-title>
                  <v-col cols="6" class="mx-auto">
                    <div class="rounded d-flex justify-center">
                      <img
                        class="mx-auto"
                        :style="
                          'width: 132px; height: 165px; border-radius: 8px; border: 0.5px solid' +
                          dadosEmpresa.corBase +
                          '; object-fit: cover'
                        "
                        :src="produtoSelecionado.img_url"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <p class="pa-0" style="opacity: 60%">
                      {{ produtoSelecionado.descricao }}
                    </p>
                  </v-col>
                  <v-divider></v-divider>
                  <v-card-title>
                    <v-col
                      class="ml-n3"
                      cols="12"
                      v-if="produtoSelecionado.saborComp"
                    >
                      <p style="opacity: 60%; font-size: 15px">
                        Maximo de sabores:
                        {{
                          produtoSelecionado.limiteSaborUnic
                            ? produtoSelecionado.limiteSaborUnic
                            : 1
                        }}
                      </p>
                      <p
                        :style="
                          'font-size: 15px; color:' + dadosEmpresa.corBase
                        "
                        v-if="
                          produtoSelecionado.limiteSaborUnic
                            ? produtoSelecionado.limiteSaborUnic <
                              produtoSelecionado.saborSelecionado.length
                            : 1 < produtoSelecionado.saborSelecionado.length
                        "
                      >
                        Selecione sabores de acordo com o limite
                      </p>
                      <v-list
                        v-model:opened="open"
                        style="width: 108%"
                        class="pulse"
                      >
                        <v-list-group value="Sabores">
                          <template v-slot:activator="{ props }">
                            <v-list-item
                              :class="
                                this.open.find((val) => val == 'Sabores')
                                  ? 'bg-grey'
                                  : ''
                              "
                              v-bind="props"
                              prepend-icon="mdi-food-outline"
                              title="Sabores"
                            ></v-list-item>
                          </template>
                          <template
                            v-for="sabor in produtoSelecionado.valorSaborComposto"
                            v-key="sabor"
                          >
                            <v-list-item
                              :class="
                                produtoSelecionado.saborSelecionado.findIndex(
                                  (val) => val == sabor,
                                ) != -1
                                  ? 'bg-green'
                                  : ''
                              "
                              :disabled="
                                produtoSelecionado.saborSelecionado != '' &&
                                !produtoSelecionado.saborSelecionado.find(
                                  (val) => val == sabor,
                                ) &&
                                produtoSelecionado.saborSelecionado.length ==
                                  (produtoSelecionado.limiteSaborUnic
                                    ? produtoSelecionado.limiteSaborUnic
                                    : 1)
                              "
                              @click="
                                produtoSelecionado.saborSelecionado.findIndex(
                                  (val) => val == sabor,
                                ) != -1
                                  ? produtoSelecionado.saborSelecionado.splice(
                                      produtoSelecionado.saborSelecionado.findIndex(
                                        (val) => val == sabor,
                                      ),
                                      1,
                                    )
                                  : produtoSelecionado.saborSelecionado.push(
                                      sabor,
                                    )
                              "
                              style="cursor: pointer"
                            >
                              <v-list-item-title>{{
                                sabor.descricao
                              }}</v-list-item-title>

                              <v-list-item-subtitle>
                                {{ sabor.valor }}
                              </v-list-item-subtitle>
                            </v-list-item>
                          </template>
                        </v-list-group>
                      </v-list>
                    </v-col>
                    <v-col
                      class="ml-n3"
                      cols="12"
                      v-if="produtoSelecionado.adicionais == 'true'"
                    >
                      <v-list v-model:opened="open" style="width: 108%">
                        <v-list-group value="Adicionais">
                          <template v-slot:activator="{ props }">
                            <v-list-item
                              :class="
                                this.open.find((val) => val == 'Adicionais')
                                  ? 'bg-grey'
                                  : ''
                              "
                              v-bind="props"
                              prepend-icon="mdi-hamburger-plus"
                              title="Adicionais"
                            ></v-list-item>
                          </template>
                          <template
                            v-for="adicional in produtoSelecionado.valorAdicionais"
                            v-key="sabor"
                          >
                            <v-list-item
                              :class="
                                produtoSelecionado.adicionaisSelecionados !=
                                  undefined &&
                                produtoSelecionado.adicionaisSelecionados.findIndex(
                                  (val) => val == adicional,
                                ) != -1
                                  ? 'bg-green'
                                  : ''
                              "
                              @click="
                                this.produtoSelecionado.adicionaisSelecionados =
                                  ((value =
                                    this.produtoSelecionado
                                      .adicionaisSelecionados === undefined
                                      ? []
                                      : this.produtoSelecionado
                                          .adicionaisSelecionados),
                                  (index = value.findIndex(
                                    (val) => val === adicional,
                                  )),
                                  index === -1
                                    ? value.push(adicional)
                                    : value.splice(index, 1),
                                  value)
                              "
                              style="cursor: pointer"
                            >
                              <v-list-item-title>{{
                                adicional.descricao
                              }}</v-list-item-title>
                              <v-list-item-subtitle>
                                {{ adicional.valor }}
                              </v-list-item-subtitle>
                            </v-list-item>
                          </template>
                        </v-list-group>
                      </v-list>
                    </v-col>
                  </v-card-title>
                  <v-card-actions class="d-flex justify-center">
                    <p style="opacity: 60%">Quantidade:</p>

                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      size="large"
                      icon
                      v-if="produtoSelecionado.quantidade >= 2"
                      @click="
                        (produtoSelecionado.quantidade -= 1), (reveal = true)
                      "
                    >
                      <v-icon size="large" :color="dadosEmpresa.corBase"
                        >mdi-minus-circle-outline</v-icon
                      >
                    </v-btn>

                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      v-if="produtoSelecionado.quantidade == 1"
                      size="large"
                      icon
                      @click="
                        (reveal = true),
                          (produtoSelecionado.quantidade = 0),
                          removeCarrinho(produtoSelecionado)
                      "
                    >
                      <v-icon size="large" :color="dadosEmpresa.corBase"
                        >mdi-minus-circle-outline</v-icon
                      >
                    </v-btn>
                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      size="large"
                      icon
                      disabled
                      v-if="produtoSelecionado.quantidade == 0"
                    >
                      <v-icon size="large" :color="dadosEmpresa.corBase"
                        >mdi-minus-circle-outline</v-icon
                      >
                    </v-btn>
                    <v-card-subtitle class="mt-1">
                      <p
                        :style="
                          'font-size:14px; color: ' + dadosEmpresa.corBase
                        "
                      >
                        {{ produtoSelecionado.quantidade }} x
                      </p>
                    </v-card-subtitle>
                    <v-btn
                      id="valor"
                      v-if="produtoSelecionado.quantidade < 1"
                      :disabled="
                        !this.horario && this.mutableSelecionado == 'Delivery'
                      "
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      size="large"
                      icon
                      @click="
                        (produtoSelecionado.quantidade += 1), (reveal = true)
                      "
                    >
                      <v-icon size="large" :color="dadosEmpresa.corBase"
                        >mdi-plus-circle-outline</v-icon
                      >
                    </v-btn>

                    <v-btn
                      v-if="produtoSelecionado.quantidade >= 1"
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      size="large"
                      icon
                      @click="
                        (produtoSelecionado.quantidade += 1), (reveal = true)
                      "
                    >
                      <v-icon size="large" :color="dadosEmpresa.corBase"
                        >mdi-plus-circle-outline</v-icon
                      >
                    </v-btn>
                  </v-card-actions>
                </v-card>
                <div class="d-flex">
                  <v-btn
                    class="bg-red"
                    style="width: 50%; border-radius: 0px; height: 50px"
                    @click="
                      (this.produtoSelecionado.dialog = false),
                        desabilitaScroll(),
                        (this.open = [])
                    "
                    elevation="0"
                    >Voltar
                    <v-icon color="white">mdi-arrow-left-bottom</v-icon></v-btn
                  >
                  <div style="width: 50%" @click="alertaSelect()">
                    <v-btn
                      style="width: 100%; border-radius: 0px; height: 50px"
                      class="bg-green"
                      :disabled="
                        produtoSelecionado.quantidade == 0 ||
                        validaDisabledSabor(produtoSelecionado, true)
                      "
                      @click="
                        enviaPreco(produtoSelecionado),
                          (this.produtoSelecionado.dialog = false),
                          this.getProdutos(),
                          desabilitaScroll(),
                          (this.open = [])
                      "
                      >adicionar <v-icon>mdi-plus</v-icon></v-btn
                    >
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <div
            class="dialogFeito"
            style="overflow-y: scroll"
            v-if="produtoSelecionado.dialog && produtoSelecionado.tamanhoComp"
          >
            <v-row>
              <v-col class="mx-auto" cols="12" md="4" id="dialogCol">
                <v-card
                  style="overflow-y: auto !important"
                  class="px-5"
                  id="dialogCard"
                >
                  <v-row class="d-flex justify-end">
                    <v-col cols="1" class="mr-3">
                      <v-btn
                        class="mt-5"
                        size="md"
                        @click="
                          (this.produtoSelecionado.dialog = false),
                            desabilitaScroll(),
                            (this.open = [])
                        "
                        elevation="0"
                        icon
                      >
                        <v-icon color="red">mdi-close</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                  <v-card-title>{{ produtoSelecionado.nome }}</v-card-title>
                  <v-col cols="6" class="mx-auto">
                    <div class="rounded d-flex justify-center">
                      <img
                        class="mx-auto"
                        :style="
                          'width: 132px; height: 165px; border-radius: 8px; border: 0.5px solid' +
                          dadosEmpresa.corBase +
                          '; object-fit: cover'
                        "
                        :src="produtoSelecionado.img_url"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <p class="pa-0" style="opacity: 60%">
                      {{ produtoSelecionado.descricao }}
                    </p>
                  </v-col>
                  <v-divider></v-divider>
                  <v-card-title>
                    <v-col class="ml-n3" cols="12">
                      <v-list
                        v-model:opened="open"
                        style="width: 108%"
                        class="pulseTamanho"
                      >
                        <v-list-group value="Tamanhos">
                          <template v-slot:activator="{ props }">
                            <v-list-item
                              :class="
                                this.open.find((val) => val == 'Tamanhos')
                                  ? 'bg-grey'
                                  : ''
                              "
                              v-bind="props"
                              prepend-icon="mdi-arrow-expand-all"
                              title="Tamanhos"
                            ></v-list-item>
                          </template>
                          <template
                            v-for="tamanho in produtoSelecionado.valorTamComposto"
                            v-key="tamanho"
                          >
                            <div
                              :class="
                                produtoSelecionado.tamSelecionado == tamanho
                                  ? 'bg-green' + ' pl-15 pb-1 pt-1'
                                  : '' + ' pl-15 pb-1 pt-1'
                              "
                              :style="
                                produtoSelecionado.tamSelecionado == ''
                                  ? 'background-color: white !important'
                                  : ''
                              "
                              value="tamanho"
                              @click="
                                produtoSelecionado.tamSelecionado = tamanho
                              "
                              style="cursor: pointer"
                            >
                              <v-list-item-title
                                class="pl-3"
                                @click="isActive = true"
                                >{{ tamanho.descricao }}</v-list-item-title
                              >

                              <v-list-item-subtitle class="pl-3">
                                {{ tamanho.valor }}
                              </v-list-item-subtitle>
                            </div>
                          </template>
                        </v-list-group>
                      </v-list>
                    </v-col>
                    <v-col
                      class="ml-n3"
                      cols="12"
                      v-if="produtoSelecionado.saborComp"
                    >
                      <p style="opacity: 60%; font-size: 15px">
                        Maximo de sabores:
                        {{
                          produtoSelecionado.tamSelecionado.sabores
                            ? produtoSelecionado.tamSelecionado.sabores
                            : 1
                        }}
                      </p>
                      <p
                        style="color: red; font-size: 15px"
                        v-if="
                          produtoSelecionado.tamSelecionado.sabores
                            ? produtoSelecionado.tamSelecionado.sabores <
                              produtoSelecionado.saborSelecionado.length
                            : 1 < produtoSelecionado.saborSelecionado.lengt
                        "
                      >
                        Selecione sabores de acordo com o limite
                      </p>
                      <v-list
                        v-model:opened="open"
                        style="width: 108%"
                        class="pulse"
                      >
                        <v-list-group value="Sabores">
                          <template v-slot:activator="{ props }">
                            <v-list-item
                              :class="
                                this.open.find((val) => val == 'Sabores')
                                  ? 'bg-grey'
                                  : ''
                              "
                              v-bind="props"
                              prepend-icon="mdi-food-outline"
                              title="Sabores"
                            ></v-list-item>
                          </template>
                          <template
                            v-for="sabor in produtoSelecionado.valorSaborComposto"
                            v-key="sabor"
                          >
                            <v-list-item
                              :class="
                                produtoSelecionado.saborSelecionado.findIndex(
                                  (val) => val == sabor,
                                ) != -1
                                  ? 'bg-green'
                                  : ''
                              "
                              :disabled="
                                produtoSelecionado.saborSelecionado != '' &&
                                !produtoSelecionado.saborSelecionado.find(
                                  (val) => val == sabor,
                                ) &&
                                produtoSelecionado.saborSelecionado.length ==
                                  (produtoSelecionado.tamSelecionado.sabores
                                    ? produtoSelecionado.tamSelecionado.sabores
                                    : 1)
                              "
                              @click="
                                produtoSelecionado.saborSelecionado.findIndex(
                                  (val) => val == sabor,
                                ) != -1
                                  ? produtoSelecionado.saborSelecionado.splice(
                                      produtoSelecionado.saborSelecionado.findIndex(
                                        (val) => val == sabor,
                                      ),
                                      1,
                                    )
                                  : produtoSelecionado.saborSelecionado.push(
                                      sabor,
                                    )
                              "
                              style="cursor: pointer"
                            >
                              <v-list-item-title>{{
                                sabor.descricao
                              }}</v-list-item-title>

                              <v-list-item-subtitle>
                                {{ sabor.valor }}
                              </v-list-item-subtitle>
                            </v-list-item>
                          </template>
                        </v-list-group>
                      </v-list>
                    </v-col>
                    <v-col
                      class="ml-n3"
                      cols="12"
                      v-if="produtoSelecionado.adicionais == 'true'"
                    >
                      <v-list v-model:opened="open" style="width: 108%">
                        <v-list-group value="Adicionais">
                          <template v-slot:activator="{ props }">
                            <v-list-item
                              :class="
                                this.open.find((val) => val == 'Adicionais')
                                  ? 'bg-grey'
                                  : ''
                              "
                              v-bind="props"
                              prepend-icon="mdi-hamburger-plus"
                              title="Adicionais"
                            ></v-list-item>
                          </template>
                          <template
                            v-for="adicional in produtoSelecionado.valorAdicionais"
                            v-key="sabor"
                          >
                            <v-list-item
                              :class="
                                produtoSelecionado.adicionaisSelecionados !=
                                  undefined &&
                                produtoSelecionado.adicionaisSelecionados.findIndex(
                                  (val) => val == adicional,
                                ) != -1
                                  ? 'bg-green'
                                  : ''
                              "
                              @click="
                                this.produtoSelecionado.adicionaisSelecionados =
                                  ((value =
                                    this.produtoSelecionado
                                      .adicionaisSelecionados === undefined
                                      ? []
                                      : this.produtoSelecionado
                                          .adicionaisSelecionados),
                                  (index = value.findIndex(
                                    (val) => val === adicional,
                                  )),
                                  index === -1
                                    ? value.push(adicional)
                                    : value.splice(index, 1),
                                  value)
                              "
                              style="cursor: pointer"
                            >
                              <v-list-item-title>{{
                                adicional.descricao
                              }}</v-list-item-title>

                              <v-list-item-subtitle>
                                {{ adicional.valor }}
                              </v-list-item-subtitle>
                            </v-list-item>
                          </template>
                        </v-list-group>
                      </v-list>
                    </v-col>
                  </v-card-title>
                  <v-card-actions class="d-flex justify-center">
                    <p style="opacity: 60%">Quantidade:</p>

                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      size="large"
                      icon
                      v-if="produtoSelecionado.quantidade >= 2"
                      @click="
                        (produtoSelecionado.quantidade -= 1), (reveal = true)
                      "
                    >
                      <v-icon size="large" :color="dadosEmpresa.corBase"
                        >mdi-minus-circle-outline</v-icon
                      >
                    </v-btn>

                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      v-if="produtoSelecionado.quantidade == 1"
                      size="large"
                      icon
                      @click="
                        (reveal = true),
                          (produtoSelecionado.quantidade = 0),
                          removeCarrinho(produtoSelecionado)
                      "
                    >
                      <v-icon size="large" :color="dadosEmpresa.corBase"
                        >mdi-minus-circle-outline</v-icon
                      >
                    </v-btn>
                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      size="large"
                      icon
                      disabled
                      v-if="produtoSelecionado.quantidade == 0"
                    >
                      <v-icon size="large" :color="dadosEmpresa.corBase"
                        >mdi-minus-circle-outline</v-icon
                      >
                    </v-btn>

                    <v-card-subtitle class="mt-1">
                      <p
                        :style="
                          'font-size:14px; color: ' + dadosEmpresa.corBase
                        "
                      >
                        {{ produtoSelecionado.quantidade }} x
                      </p>
                    </v-card-subtitle>
                    <v-btn
                      id="valor"
                      v-if="produtoSelecionado.quantidade < 1"
                      :disabled="
                        !this.horario && this.mutableSelecionado == 'Delivery'
                      "
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      size="large"
                      icon
                      @click="
                        (produtoSelecionado.quantidade += 1), (reveal = true)
                      "
                    >
                      <v-icon size="large" :color="dadosEmpresa.corBase"
                        >mdi-plus-circle-outline</v-icon
                      >
                    </v-btn>

                    <v-btn
                      v-if="produtoSelecionado.quantidade >= 1"
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      size="large"
                      icon
                      @click="
                        (produtoSelecionado.quantidade += 1), (reveal = true)
                      "
                    >
                      <v-icon size="large" :color="dadosEmpresa.corBase"
                        >mdi-plus-circle-outline</v-icon
                      >
                    </v-btn>
                  </v-card-actions>
                </v-card>
                <div class="d-flex">
                  <v-btn
                    class="bg-red"
                    style="width: 50%; border-radius: 0px; height: 50px"
                    @click="
                      (this.produtoSelecionado.dialog = false),
                        desabilitaScroll(),
                        (this.open = [])
                    "
                    elevation="0"
                    >Voltar
                    <v-icon color="white">mdi-arrow-left-bottom</v-icon></v-btn
                  >
                  <div style="width: 50%" @click="alertaSelect()">
                    <v-btn
                      style="width: 100%; border-radius: 0px; height: 50px"
                      class="bg-green"
                      :disabled="
                        validaDisabledSabor(produtoSelecionado) ||
                        produtoSelecionado.tamSelecionado == '' ||
                        produtoSelecionado.quantidade == 0
                      "
                      @click="
                        enviaPreco(produtoSelecionado),
                          (this.produtoSelecionado.dialog = false),
                          this.getProdutos(),
                          desabilitaScroll(),
                          (this.open = [])
                      "
                      >adicionar <v-icon>mdi-plus</v-icon></v-btn
                    >
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import getCategorias from "../../libs/getCategorias";
import getProdutos from "../../libs/getProdutos";
import getCombos from "../../libs/getCombos";

import { mapGetters } from "vuex";
import { store } from "../../store/store";

import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { ref } from "vue";
export default {
  name: "listaProdutos",
  
  data() {
    return {
      open: [""],
      openCategorias: ["Combos"],
      produtoSelecionado: [],
      produtoIndex: null,
      dialog: false,
      erroSabor: false,
      dialogProduto: [],
      mutableSelecionado: "Delivery",
      valorTamComposto: [],
      mutableCarrinho: [],
      mutableprecoTotal: 0,
      categoriasPush: [],
      produtosPush: [],
      categoria: {
        id: null,
        nome: null,
      },
    };
  },
  watch: {
    dadosEmpresa(){
    },
    selecionado(n) {
      this.filtraCategorias(n), (this.mutableSelecionado = n);
    },
    produtos(n) {
      if (n != "") {
        this.getProdutos();
        this.getAdicionais();
      }
    },
    carrinho() {
      this.mutableCarrinho = JSON.parse(JSON.stringify(this.carrinho));
    },
    scrollTo() {
      if (this.scrollTo != "") {
        console.log(this.scrollTo);
        const el = document.getElementsByClassName(this.scrollTo)[0];
        const yOffset = this.$isMobile() ? -235 : -90;
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    },
  },
  computed: {
    ...mapGetters([
      "database",
      "dadosEmpresa",
      "carrinho",
      "pedidos",
      "produtos",
      "categorias",
      "horario",
      "selecionado",
      "busca",
      "scrollTo",
      "combos",
    ]),
  },
  methods: {
    validaHorario(){
      if (this.horario == false) {
        store.commit("incrementShownAlert", true);
        store.commit("incrementHorario", false);
        this.$swal.fire({
          icon: "error",
          text: `Estabelecimento fora do horário de atendimento${this.disableEncomenda == false ? '. Caso desejar, é possivel realizar encomenda.' : '.'}`,
          confirmButtonColor: "#d33",
        });
      }
    },
    checkScroll() {
      const windowHeight = window.innerHeight;

      for (let categoria of this.categoriasPush) {
        const targetDivRef = ref(null);
        targetDivRef.value = document.querySelector(`#Categoria-${categoria.id}`);
        if (targetDivRef.value) {
          const rect = targetDivRef.value.getBoundingClientRect();
          const topVisible = rect.top >= 0 && rect.top <= windowHeight;
          // const bottomVisible = rect.bottom >= 0 && rect.bottom <= windowHeight;
          if (!this.$isMobile() ? topVisible : topVisible) {
            this.load(!this.$isMobile() ? this.categoriasPush.indexOf(categoria) - 1 : this.categoriasPush.indexOf(categoria) + 1)
          }
        }
      }
    },
    alertaSelect() {
      if (this.produtoSelecionado.saborSelecionado == "") {
        var elems = document.querySelectorAll(".pulse");
        var index = 0,
          length = elems.length;
        for (; index < length; index++) {
          const elements = document.querySelectorAll(".pulse");
          elements.forEach((element) => {
            element.classList.add("animate");
            setTimeout(() => {
              element.classList.remove("animate");
            }, 2000);
          });
        }
      }
      if (this.produtoSelecionado.tamSelecionado == "") {
        elems = document.querySelectorAll(".pulse");
        (index = 0), (length = elems.length);
        for (; index < length; index++) {
          const elements = document.querySelectorAll(".pulseTamanho");
          elements.forEach((element) => {
            element.classList.add("animate");
            setTimeout(() => {
              element.classList.remove("animate");
            }, 2000);
          });
        }
      }
    },
    desabilitaScroll() {
      if (document.getElementsByTagName("body")[0].style.overflow == "hidden") {
        document.getElementsByTagName("body")[0].style.overflow = "auto";
        document.getElementsByTagName("html")[0].style.overflow = "auto";
      } else {
        document.getElementsByTagName("body")[0].style.overflow = "hidden";
        document.getElementsByTagName("html")[0].style.overflow = "hidden";
      }
    },
    validaDisabledSabor(produto, unico) {
      if (unico) {
        return produto.saborComp
          ? produto.saborSelecionado == ""
            ? true
            : produto.limiteSaborUnic
            ? produto.limiteSaborUnic < produto.saborSelecionado.length
              ? true
              : false
            : 1 < produto.saborSelecionado.length
            ? true
            : false
          : false;
      } else {
        return produto.saborComp
          ? produto.saborSelecionado == ""
            ? true
            : produto.saborSelecionado.length == 0
            ? true
            : produto.tamSelecionado.sabores
            ? produto.tamSelecionado.sabores < produto.saborSelecionado.length
              ? true
              : false
            : 1 < produto.saborSelecionado.length
            ? true
            : false
          : false;
      }
    },

    removeCarrinho(n) {
      this.mutableCarrinho = this.mutableCarrinho.filter(
        (e) => e.codbarras != n.codbarras,
      );
    },
    load(n) {
        store.commit("incrementSelecionadoCategorias", n);
    },
    filtraCategorias(n) {
      var index = [];
      this.openCategorias = ["Combos"];

      if (n == "Delivery") {
        for (var categoria of this.categorias) {
          var prod = this.produtosPush.find((val) =>
            val.delivery == false && val.encomenda == false
              ? ""
              : (val.categoria == categoria.id && val.delivery == true) ||
                (val.categoria == categoria.id &&
                  !val.delivery &&
                  !val.encomenda),
          );
          if (prod) {
            index.push(this.categorias.indexOf(categoria));
            this.openCategorias.push(categoria.nome);
          }
        }
        this.categoriasPush = this.categorias.filter((el, i) =>
          index.some((j) => i === j),
        );
        if(this.combos != '') {this.categoriasPush.unshift({id: 0, nome: 'Combos', verificador: 0})}

      } else if (n == "Encomendas") {
        for (categoria of this.categorias) {
          prod = this.produtosPush.find(
            (val) => val.categoria == categoria.id && val.encomenda,
          );
          if (prod) {
            this.openCategorias.push(categoria.nome);
            index.push(this.categorias.indexOf(categoria));
          }
        }
        this.categoriasPush = this.categorias.filter((el, i) =>
          index.some((j) => i === j),
        );
        
        if(this.combos != '') {this.categoriasPush.unshift({id: 0, nome: 'Combos', verificador: 0})}
        
      }
    },
    getProdutos() {
      this.produtosPush = JSON.parse(JSON.stringify(this.produtos));

      if (this.produtosPush != "") {
        var i = 0;
        for (i in this.produtosPush) {
          if (this.produtosPush[i].tamanhoComp == true) {
            this.produtosPush[i].tamSelecionado = [];
          }
          if (this.produtosPush[i].saborComp == true) {
            this.produtosPush[i].saborSelecionado = [];
          }
          if (this.produtosPush[i].ativado == "false") {
            console.log(this.produtosPush[i]);
            this.produtosPush.splice(i, 1);
          }
        }
      }
      // if(this.carrinho != ''){
      //   for(var val of this.produtosPush){
      //       val.quantidade = 0
      //   }
      //   for(var carrinho of this.carrinho){
      //     if(this.produtosPush.find((val) => val.codbarras == carrinho.codbarras)){
      //       this.produtosPush.find((val) => val.codbarras == carrinho.codbarras).quantidade = carrinho.quantidade
      //     } else {
      //       val.quantidade = 0
      //     }
      //   }
      // }
      this.getCategorias();
    },
    getCategorias() {
      this.filtraCategorias(this.selecionado);
    },
    async getAdicionais() {
      const docRefAdc = doc(db, process.env.VUE_APP_DATABASE, "adicionais");
      const docSnapAdc = await getDoc(docRefAdc);
      if (docSnapAdc.exists()) {
        this.adicionais = docSnapAdc.data().adicionais;
        for (var i = 0; i < this.adicionais.length; i++) {
          if (this.adicionais[i].produtos.length > 0) {
            for (var o = 0; o < this.adicionais[i].produtos.length; o++) {
              for (var b = 0; b < this.produtosPush.length; b++) {
                if (
                  this.produtosPush[b].verificador ==
                  this.adicionais[i].produtos[o]
                ) {
                  if (
                    this.produtosPush[b].valorAdicionais &&
                    this.produtosPush[b].valorAdicionais.length > 0
                  ) {
                    if (this.adicionais[i] != undefined) {
                      this.produtosPush[b].adicionais = "true";
                      this.produtosPush[b].valorAdicionais.push({
                        descricao: this.adicionais[i].descricao,
                        valor: this.adicionais[i].valor,
                      });
                    }
                  } else {
                    if (this.adicionais[i] != undefined) {
                      this.produtosPush[b].adicionais = "true";
                      this.produtosPush[b].valorAdicionais = [];
                      this.produtosPush[b].valorAdicionais.push({
                        descricao: this.adicionais[i].descricao,
                        valor: this.adicionais[i].valor,
                      });
                    }
                  }
                }
              }
            }
          }
          if (this.adicionais[i].categorias.length > 0) {
            for (var z = 0; z < this.adicionais[i].categorias.length; z++) {
              for (var x = 0; x < this.categorias.length; x++) {
                if (this.categorias[x].id == this.adicionais[i].categorias[z]) {
                  for (b = 0; b < this.produtosPush.length; b++) {
                    if (
                      this.produtosPush[b].categoria == this.categorias[x].id
                    ) {
                      if (
                        this.produtosPush[b].valorAdicionais &&
                        this.produtosPush[b].valorAdicionais.length > 0
                      ) {
                        if (this.adicionais[i].categorias != undefined) {
                          this.produtosPush[b].adicionais = "true";
                          this.produtosPush[b].valorAdicionais.push({
                            descricao: this.adicionais[i].descricao,
                            valor: this.adicionais[i].valor,
                          });
                        }
                      } else {
                        if (this.adicionais[i].categorias != undefined) {
                          this.produtosPush[b].adicionais = "true";
                          this.produtosPush[b].valorAdicionais = [];
                          this.produtosPush[b].valorAdicionais.push({
                            descricao: this.adicionais[i].descricao,
                            valor: this.adicionais[i].valor,
                          });
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    enviaPreco(produto) {
      this.mutableCarrinho.push(produto);

      if (
        this.mutableCarrinho[0].encomenda &&
        this.mutableSelecionado == "Encomendas"
      ) {
        this.disableDelivery = true;
      } else {
        this.disableEncomenda = true;
      }
      if (this.mutableCarrinho.length == 0) {
        this.disableDelivery = false;
        this.disableEncomenda = false;
      }
      this.getAdicionais();

      store.commit("incrementDisableDelivery", this.disableDelivery);

      store.commit("incrementDisableEncomenda", this.disableEncomenda);

      store.commit("incrementSelecionado", this.mutableSelecionado);

      store.commit("incrementCarrinho", this.mutableCarrinho);
    },

    descricaoAdicionais(i) {
      this.mutableCarrinho[i].adicionaisDesc = null;
      for (var b = 0; b < this.mutableCarrinho[i].valorAdicionais.length; b++) {
        for (
          var c = 0;
          c < this.mutableCarrinho[i].adicionaisSelecionados.length;
          c++
        ) {
          if (
            this.mutableCarrinho[i].valorAdicionais[b].valor ==
            this.mutableCarrinho[i].adicionaisSelecionados[c]
          ) {
            if (this.mutableCarrinho[i].adicionaisDesc == null) {
              this.mutableCarrinho[i].adicionaisDesc =
                this.mutableCarrinho[i].valorAdicionais[b].descricao;
            } else {
              this.mutableCarrinho[i].adicionaisDesc +=
                ", " + this.mutableCarrinho[i].valorAdicionais[b].descricao;
            }
          }
        }
      }
    },
    defineMetaTags(){
      let ogTitleTag = document.querySelector('meta[property="og:title"]');
      let ogDescriptionTag = document.querySelector('meta[property="og:description"]');
      let ogImageTag = document.querySelector('meta[property="og:image"]');
      let descriptionTag = document.querySelector('meta[name="description"]'); // Select the standard description meta tag

      // Check if the meta tags exist; if not, create and append them to the document's head
      if (!ogTitleTag) {
        ogTitleTag = document.createElement('meta');
        ogTitleTag.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitleTag);
      } 
      if (!ogDescriptionTag) {
        ogDescriptionTag = document.createElement('meta');
        ogDescriptionTag.setAttribute('property', 'og:description');
        document.head.appendChild(ogDescriptionTag);
      }

      if (!ogImageTag) {
        ogImageTag = document.createElement('meta');
        ogImageTag.setAttribute('property', 'og:image');
        document.head.appendChild(ogImageTag);
      }

      if (!descriptionTag) {
        descriptionTag = document.createElement('meta');
        descriptionTag.setAttribute('name', 'description'); // Set the name attribute for the standard description
        document.head.appendChild(descriptionTag);
      }
    },
    setMetaTags(){
      let ogTitleTag = document.querySelector('meta[property="og:title"]');
      let ogDescriptionTag = document.querySelector('meta[property="og:description"]');
      let ogImageTag = document.querySelector('meta[property="og:image"]');
      let descriptionTag = document.querySelector('meta[name="description"]');

      ogTitleTag.setAttribute('content', this.dadosEmpresa.nome + ' | Delivery Ibo-Solutions');
      ogDescriptionTag.setAttribute('content', this.dadosEmpresa.nome + ' | Delivery Ibo-Solutions');
      ogImageTag.setAttribute('content', this.dadosEmpresa.img_url);
      document.title = this.dadosEmpresa.nome
      descriptionTag.setAttribute('content', this.dadosEmpresa.nome + ' | Delivery Ibo-Solutions');

    }
  },
  beforeUnmount() {
    // Remove the scroll event listener when the component is destroyed
    window.removeEventListener("scroll", this.checkScroll);
  },
  async created() {
    setTimeout(() => {
      window.addEventListener("scroll", this.checkScroll);
    }, 500);
    
    getCategorias(this.database);

    getProdutos(this.database);

    getCombos(this.database);

    for (var produtos of this.produtosPush) {
      produtos.quantidade = 0;
    }
    this.combos.forEach((val) => {
      if (val.quantiade != 0) {
        val.quantidade = 0;
      }
    });
    //this.getCategorias(),

  },
  activated() {
    if (this.produtos != "") {
      if (this.carrinho != "") {
        this.mutableCarrinho = JSON.parse(JSON.stringify(this.carrinho));
        this.getProdutos();
        this.getAdicionais();
      } else {
        this.disableEncomenda = false;
        this.disableDelivery = false;
        store.commit("incrementDisableDelivery", this.disableDelivery);
        store.commit("incrementDisableEncomenda", this.disableEncomenda);
      }
      for (var produtos of this.produtosPush) {
        produtos.quantidade = 0;
      }
      this.combos.forEach((val) => {
        if (val.quantiade != 0) {
          val.quantidade = 0;
        }
      });
    }
   

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#vcardProduto:hover {
  transform: scale(1.05) translate3d(0px, 0px, 0px);
}

.spinner {
  display: none;
}
#dialogCard {
  max-height: 84vh;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
}

#dialogFeitoCombos {
  transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -webkit-backdrop-filter: brightness(45%);
  backdrop-filter: brightness(45%);
  z-index: 3;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  /* iOS */
  display: -webkit-box;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  position: fixed;
  align-items: center;
  justify-content: center;
  display: flex;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.dialogFeito {
  transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -webkit-backdrop-filter: brightness(45%);
  backdrop-filter: brightness(45%);
  z-index: 3;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  /* iOS */
  display: -webkit-box;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  position: fixed;
  align-items: center;
  justify-content: center;
  display: flex;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

#dialogCol {
  transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
.pulse,
.pulseTamanho {
  --border-color: #f44a3e;
  --border-width: 3px;
  --bottom-distance: 0px; /* you can increase this */
  color: #666;
  display: inline-block;
  background-image: linear-gradient(var(--border-color), var(--border-color));
  background-size: 0% var(--border-width);
  background-repeat: no-repeat;
  transition: background-size 0.3s;
  margin: 5px 0;
  background-position: 50% calc(100% - var(--bottom-distance));
}

.pulse.animate,
.pulseTamanho.animate {
  background-size: 100% var(--border-width);
}

.pulse.animate:after,
.pulseTamanho.animate:after {
  transform: scaleX(1);
}
</style>
